<div class="layout-footer flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-sm text-surface-500">
    <span>MyDocs — Plataforma de gestão documental segura e colaborativa.</span>
    <span>© {{ currentYear }} MyDocs. Todos os direitos reservados.</span>
    <a href="mailto:suporte&#64;mydocs.com" class="text-primary font-bold hover:underline">suporte&#64;mydocs.com</a>
</div>